import { useAppStore } from '@store'
import { Area, BackMaterialInfo } from '@types'
import { toVector3 } from '@utils/conversion/toVector3'
import { Euler } from 'three'
import areaImg from '../../../assets/area.png'
type Props = Partial<Omit<Area, 'type' | 'image'>> & { id: string }

export function getBaseArea(props: Props): Area {
  // TODO: Pasarle la store y no usar la guarrada de getState
  // TODO: Evitar esos condicionales feos de abajo si faltan cosas
  const texture1 = useAppStore.getState().texture1
  const texture4 = useAppStore.getState().texture4
  const increment = useAppStore.getState().increment
  const textureToAdd = props.isRoof ? texture4 : texture1
  useAppStore.getState().addIncrement()

  let baseArea = {
    sides: [] as string[],
    isClosed: false,
    type: 'areas',
    isRoof: false,
    image: areaImg,
    height: 0,
    textures: [],
    zones: {},
    universal: true,
    catalogID: '',
    idUnidades: -1,
    visible: true,
    ceilingVisible: true,
    url: '',
    description: '',
    increment: increment,
  } satisfies Partial<Area>
  if (texture4) {
    if (texture1) {
      baseArea = {
        sides: [] as string[],
        isClosed: false,
        increment,
        type: 'areas',
        isRoof: false,
        image: areaImg,
        height: 0,
        visible: true,
        zones: {
          area: {
            position: toVector3(),
            scale: toVector3(),
            rotation: new Euler(),
            name: 'area',
            index: 0,
            material: { ...textureToAdd },
          },
        },
        textures: [
          {
            id: textureToAdd?.id,
            searchID: textureToAdd?.searchID,
            zoneName: 'area',
            zoneDisplayName: 'MSG_182',
            url: textureToAdd?.url,
            name: textureToAdd?.name,
            zone: 'area',
            groupID: textureToAdd?.groupID,
          },
        ] as BackMaterialInfo[],
      } satisfies Partial<Area>
    } else {
      return baseArea
    }
  } else {
    return baseArea
  }
  if (!props) return baseArea

  for (const [key, value] of Object.entries(props)) {
    if (!key) continue
    baseArea[key] = value
  }
  if (!props.isRoof) {
    baseArea.description = 'MSG_252'
  }
  if (props.isRoof) {
    baseArea.description = 'MSG_273'
  }
  return baseArea as unknown as Area
}
